import React from 'react';
import Hero from '../components/home/Hero';
import VideoSection from '../components/home/VideoSection';
import MeetHeroes from '../components/home/MeetHeroes';
import WhySection from '../components/home/WhySection';
import HostCourseSection from '../components/home/HostCourseSection';
import ExploreWorkshopsSection from '../components/home/ExploreWorkshopsSection';
import FinalCTASection from '../components/home/FinalCTASection';


const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      <Hero />
      <VideoSection />
      <MeetHeroes />
      <WhySection />
      <div id="host-course">
        <HostCourseSection />
      </div>
     
      <ExploreWorkshopsSection />
  
      <FinalCTASection />
    </div>
  );
};

export default HomePage;
